import React from "react";
import { Box, Typography, Button, Card, CardContent, Divider, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { validateTextContent } from "../../utils/validateTextContent.utils";

import { format } from "date-fns";
import { Loader } from "../../components/ui/Loader";
import { useNavigate } from "react-router-dom";

export const Desafio = ({ desafio, closeModal }) => {
    const navigate = useNavigate();

    const formatField = (field, fallback) => {
        if (!field) return fallback;
        
        if (field.includes('-')) {
            const [ano, mes, dia] = field.split('-');
            return `${dia.substring(0, 2)}/${mes}/${ano}`;
        }
        
        return field;
    };

    const handlePublishChallenge = () => {
        if (!desafio?.comunidade) return;

        navigate(`/novoPost/${desafio.comunidade}`, {
            state: { comunidade: { id: desafio.comunidade }, desafio },
        });
    };

    if (!desafio) {
        return <Loader />;
    }

    return (
        <>
            <Card
                sx={{
                    width: "90%",
                    maxWidth: "100%",
                    px: 5,
                    py: 0,
                    borderRadius: "8px",
                    backgroundColor: "var(--white-color)",
                    boxShadow: "none",
                }}
            >
                {desafio.titulo && (
                    <Box display="flex" justifyContent="space-between" alignItems="center" marginBottom={2}>
                        <Typography variant="h5" fontWeight="bold" sx={{ color: "var(--grey-800-color)" }}>
                            DESAFIO: {desafio.titulo}
                        </Typography>
                        <IconButton onClick={closeModal}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                )}
                <Divider sx={{ marginBottom: 2 }} />

                <CardContent
                    sx={{
                        padding: 0,
                        maxHeight: "calc(90vh - 100px)",
                        overflowY: "auto",
                        marginBottom: "60px",
                    }}
                >
                    {desafio.pontos && (
                        <Box marginBottom={2}>
                            <Typography variant="body1" fontWeight="bold" gutterBottom>
                                Recompensa
                            </Typography>
                            <Box display="flex" alignItems="center" gap={1}>
                                <WorkspacePremiumIcon fontSize="small" />
                                <Typography variant="body1">{desafio.pontos} pontos</Typography>
                            </Box>
                        </Box>
                    )}
                    <Box
                        marginBottom={4}
                        display="flex"
                        alignItems="center"
                        gap={4}
                    >
                        <Box>
                            <Typography variant="body1" fontWeight="bold" gutterBottom>
                                Data de início
                            </Typography>
                            <Box display="flex" alignItems="center" gap={1}>
                                <CalendarTodayIcon fontSize="small" />
                                <Typography variant="body1">
                                    {formatField(desafio.data_inicio, "Sem prazo definido")}
                                </Typography>
                            </Box>
                        </Box>
                        <Box>
                            <Typography variant="body1" fontWeight="bold" gutterBottom>
                                Data de término
                            </Typography>
                            <Box display="flex" alignItems="center" gap={1}>
                                <CalendarTodayIcon fontSize="small" />
                                <Typography variant="body1">
                                    {formatField(desafio.data_fim, "Sem prazo definido")}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>

                    {validateTextContent(desafio.detalhes) && (
                        <Box marginBottom={2}>
                            <Typography variant="body1" fontWeight="bold" gutterBottom>
                                Detalhes do desafio
                            </Typography>
                            <Typography variant="body1" dangerouslySetInnerHTML={{ __html: desafio.detalhes }} />
                        </Box>
                    )}
                </CardContent>

                <Box
                    sx={{
                        position: "absolute",
                        bottom: 40,
                        left: 40,
                        right: 40,
                        backgroundColor: "white",
                        zIndex: 1,
                    }}
                >
                    <Button
                        fullWidth
                        variant="contained"
                        onClick={handlePublishChallenge}
                        sx={{
                            backgroundColor: "var(--primary-color)",
                            color: "var(--white-color)",
                            "&:hover": {
                                backgroundColor: "var(--primary-light-color)",
                            },
                        }}
                    >
                        PUBLICAR DESAFIO
                    </Button>
                </Box>
            </Card>
        </>
    );
};
